import React from "react";

function DropdownIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ width: "1em", height: "1em", verticalAlign: "middle" }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path d="M680.14 414.976c9.934-8.704 24.218-6.656 31.898 4.608a27.802 27.802 0 01-4.096 35.84L535.91 605.184a35.635 35.635 0 01-47.82 0L316.058 455.475a27.802 27.802 0 01-4.096-35.942c7.68-11.162 22.016-13.21 31.897-4.608L512 561.305l168.14-146.278z"></path>
    </svg>
  );
}

export default DropdownIcon;
